import { render, staticRenderFns } from "./Pagamento.vue?vue&type=template&id=4d48fd7c"
import script from "./Pagamento.vue?vue&type=script&lang=js"
export * from "./Pagamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports